import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import SchemaOrg from '../../../components/feature/SchemaOrg';

const YilanAreaPage = () => {
  useEffect(() => {
    document.title = '宜蘭縣搬家服務【建鈞精緻搬家】宜蘭市、羅東鎮、蘇澳鎮、冬山鄉搬家公司｜廢棄物清運｜24小時服務';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '建鈞精緻搬家提供宜蘭縣全區專業搬家服務：宜蘭市搬家、羅東鎮搬家、蘇澳鎮搬家、冬山鄉搬家、三星鄉搬家等。套房搬遷、家庭搬家、辦公室搬遷、廢棄物清運、民宿搬家。24小時免費估價：0978-900-081');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', '宜蘭縣搬家,宜蘭市搬家,羅東鎮搬家,蘇澳鎮搬家,冬山鄉搬家,三星鄉搬家,宜蘭搬家公司,宜蘭廢棄物清運,宜蘭垃圾處理,宜蘭搬家推薦,宜蘭24小時搬家,宜蘭搬家費用,建鈞搬家宜蘭,宜蘭專業搬家,礁溪民宿搬家');
    }

    const updateGeoTag = (name: string, content: string) => {
      let meta = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement;
      if (!meta) {
        meta = document.createElement('meta');
        meta.name = name;
        document.head.appendChild(meta);
      }
      meta.content = content;
    };

    updateGeoTag('geo.region', 'TW-ILA');
    updateGeoTag('geo.placename', '宜蘭縣');
    updateGeoTag('geo.position', '24.7021;121.7378');

    // 加入 Schema.org LocalBusiness 結構化資料
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "宜蘭搬家公司 - 專業搬家服務",
      "image": "https://public.readdy.ai/ai/img_res/c330d493d3fd7b008835bd41b31abfaa.jpg",
      "@id": "https://yourdomain.com/area/yilan",
      "url": "https://yourdomain.com/area/yilan",
      "telephone": "+886-800-888-888",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "宜蘭市中山路",
        "addressLocality": "宜蘭市",
        "addressRegion": "宜蘭縣",
        "postalCode": "260",
        "addressCountry": "TW"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 24.7570,
        "longitude": 121.7533
      },
      "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday"
        ],
        "opens": "00:00",
        "closes": "23:59"
      },
      "sameAs": [
        "https://www.facebook.com/yourpage",
        "https://www.instagram.com/yourpage"
      ],
      "priceRange": "$$",
      "areaServed": [
        {
          "@type": "City",
          "name": "宜蘭市",
          "containedIn": {
            "@type": "State",
            "name": "宜蘭縣"
          }
        },
        {
          "@type": "City",
          "name": "羅東鎮",
          "containedIn": {
            "@type": "State",
            "name": "宜蘭縣"
          }
        },
        {
          "@type": "City",
          "name": "蘇澳鎮",
          "containedIn": {
            "@type": "State",
            "name": "宜蘭縣"
          }
        },
        {
          "@type": "City",
          "name": "頭城鎮",
          "containedIn": {
            "@type": "State",
            "name": "宜蘭縣"
          }
        },
        {
          "@type": "City",
          "name": "礁溪鄉",
          "containedIn": {
            "@type": "State",
            "name": "宜蘭縣"
          }
        },
        {
          "@type": "City",
          "name": "壯圍鄉",
          "containedIn": {
            "@type": "State",
            "name": "宜蘭縣"
          }
        },
        {
          "@type": "City",
          "name": "員山鄉",
          "containedIn": {
            "@type": "State",
            "name": "宜蘭縣"
          }
        },
        {
          "@type": "City",
          "name": "冬山鄉",
          "containedIn": {
            "@type": "State",
            "name": "宜蘭縣"
          }
        },
        {
          "@type": "City",
          "name": "五結鄉",
          "containedIn": {
            "@type": "State",
            "name": "宜蘭縣"
          }
        },
        {
          "@type": "City",
          "name": "三星鄉",
          "containedIn": {
            "@type": "State",
            "name": "宜蘭縣"
          }
        },
        {
          "@type": "City",
          "name": "大同鄉",
          "containedIn": {
            "@type": "State",
            "name": "宜蘭縣"
          }
        },
        {
          "@type": "City",
          "name": "南澳鄉",
          "containedIn": {
            "@type": "State",
            "name": "宜蘭縣"
          }
        }
      ],
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "128"
      }
    });
    document.head.appendChild(script);

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  const districts = [
    { name: '宜蘭市', description: '縣政府所在地，商業中心', highlight: true },
    { name: '羅東鎮', description: '宜蘭第二大城，夜市著名', highlight: true },
    { name: '蘇澳鎮', description: '港口城市，冷泉勝地', highlight: true },
    { name: '頭城鎮', description: '開蘭第一城，海岸線美', highlight: true },
    { name: '礁溪鄉', description: '溫泉之鄉，觀光發達' },
    { name: '壯圍鄉', description: '農業為主，哈密瓜產地' },
    { name: '員山鄉', description: '溫泉資源豐富，自然生態' },
    { name: '冬山鄉', description: '河岸風光，綠色博覽會' },
    { name: '五結鄉', description: '傳藝中心，文化觀光' },
    { name: '三星鄉', description: '上將梨故鄉，農業精緻' },
    { name: '大同鄉', description: '原住民鄉，太平山林場' },
    { name: '南澳鄉', description: '原住民鄉，自然生態豐富' }
  ];

  const services = [
    {
      title: '宜蘭市搬家服務',
      icon: 'ri-government-line',
      description: '縣政府所在地搬家服務，包含市區住宅、商業區、政府機關周邊搬遷',
      areas: ['中山路', '民權路', '聖後街', '光復路', '北門口', '東門', '西門', '南門'],
      color: 'cyan'
    },
    {
      title: '羅東鎮搬家服務',
      icon: 'ri-community-line',
      description: '宜蘭第二大城搬家，夜市商圈、住宅區、透天厝搬遷服務',
      areas: ['中正路', '公正路', '興東路', '中山路', '羅東里', '仁愛里', '信義里', '大新里'],
      color: 'teal'
    },
    {
      title: '蘇澳鎮搬家服務',
      icon: 'ri-ship-line',
      description: '港口城市搬家，包含漁港區、工業區、住宅區及觀光區搬遷',
      areas: ['中山路', '蘇東里', '蘇西里', '蘇北里', '蘇南里', '聖愛里', '永春里', '永光里'],
      color: 'blue'
    },
    {
      title: '礁溪鄉搬家服務',
      icon: 'ri-drop-line',
      description: '溫泉鄉搬家服務，民宿、飯店、住宅區搬遷，溫泉設備專業處理',
      areas: ['礁溪路', '溫泉路', '中山路', '德陽路', '礁溪里', '白雲里', '林美里', '玉田里'],
      color: 'emerald'
    }
  ];

  const features = [
    {
      icon: 'ri-mountain-line',
      title: '山區專業',
      description: '熟悉宜蘭山區道路，太平山、大同鄉皆可服務',
      color: 'green'
    },
    {
      icon: 'ri-water-percent-line',
      title: '溫泉設備',
      description: '專業處理溫泉管線、設備拆裝服務',
      color: 'cyan'
    },
    {
      icon: 'ri-leaf-line',
      title: '農產包裝',
      description: '配合宜蘭農業特色，提供農產品搬運包裝',
      color: 'emerald'
    },
    {
      icon: 'ri-hotel-line',
      title: '民宿搬家',
      description: '專業民宿、飯店搬遷，觀光設備妥善處理',
      color: 'teal'
    }
  ];

  const faqs = [
    {
      question: '宜蘭搬家公司推薦哪一家？',
      answer: '建鈞精緻搬家服務宜蘭縣 12 個鄉鎮市，4.8 分高評價，156 則客戶好評，熟悉宜蘭溫泉區、山區、海岸地形特色，提供 24 小時免費估價服務。'
    },
    {
      question: '宜蘭搬家費用怎麼算？',
      answer: '依據搬家規模、樓層、距離計價。套房搬遷 3,000 元起，家庭搬家 3,000-8,000 元，辦公室搬遷 5,000-20,000 元。山區、溫泉區搬家會酌收遠程費，雙邊電梯優惠價 3,000 元起。'
    },
    {
      question: '宜蘭搬家當天可以預約嗎？',
      answer: '建議提前 3-7 天預約，旺季（週末、月底、觀光旺季）建議提前 2 週。急件可來電 0978-900-081 詢問，我們會盡力安排。'
    },
    {
      question: '礁溪溫泉民宿搬家怎麼處理？',
      answer: '我們有專業的溫泉設備處理經驗，包含溫泉管線拆裝、溫泉設備搬運、民宿家具保護等。礁溪地區民宿搬家案例豐富，可提供完整規劃。'
    },
    {
      question: '宜蘭山區搬家要注意什麼？',
      answer: '宜蘭山區如太平山、大同鄉道路較窄，部分路段坡度較陡。我們使用適合山區的搬運車輛，並熟悉各鄉鎮道路狀況，確保搬運安全順利。'
    },
    {
      question: '宜蘭搬家什麼時間最便宜？',
      answer: '平日（週一至週五）價格較優惠，避開月初、月底、週末、連假等旺季。淡季（1-2月、7-8月）價格更實惠，建議提前規劃搬家時間。'
    }
  ];

  const testimonials = [
    {
      name: '張老闆',
      location: '礁溪鄉',
      content: '民宿重新裝修，建鈞搬家協助傢俱暫存和復位，對溫泉設備也很有經驗，很專業！',
      rating: 5,
      service: '民宿搬遷'
    },
    {
      name: '林小姐',
      location: '宜蘭市',
      content: '從台北搬回宜蘭定居，師傅們很熟悉當地環境，搬家過程很順利，推薦給大家。',
      rating: 5,
      service: '家庭搬遷'
    },
    {
      name: '陳經理',
      location: '羅東鎮',
      content: '公司搬遷，配合度很高，連假日都願意服務，而且價格合理，值得信賴。',
      rating: 5,
      service: '辦公室搬遷'
    }
  ];

  const nearbyAreas = [
    { name: '台北市', path: '/area/taipei', description: '台北市搬家服務' },
    { name: '新北市', path: '/area/new-taipei', description: '新北市搬家服務' },
    { name: '基隆市', path: '/area/keelung', description: '基隆市搬家服務' }
  ];

  return (
    <div className="min-h-screen bg-white">
      <SchemaOrg 
        type="localbusiness" 
        data={{
          businessName: '建鈞精緻搬家-宜蘭服務處',
          businessDescription: '提供宜蘭縣全區專業搬家服務，包含宜蘭市、羅東鎮、蘇澳鎮、礁溪鄉等12個鄉鎮市搬家、廢棄物清運服務'
        }}
      />
      <SchemaOrg 
        type="service" 
        data={{
          serviceName: '宜蘭縣搬家服務',
          serviceDescription: '專業宜蘭縣搬家公司，提供套房搬遷、家庭搬家、辦公室搬遷、廢棄物清運、民宿搬家等服務',
          servicePrice: '3000'
        }}
      />

      {/* 右上角導航選單 */}
      <div className="absolute top-8 right-8 flex gap-6 text-sm font-medium z-10">
        <Link 
          to="/"
          className="text-gray-700 hover:text-cyan-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5 group"
        >
          <i className="ri-home-4-line text-base group-hover:scale-110 transition-transform"></i>
          <span>首頁</span>
        </Link>
        <Link 
          to="/services"
          className="text-gray-700 hover:text-cyan-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5 group"
        >
          <i className="ri-service-line text-base group-hover:scale-110 transition-transform"></i>
          <span>服務項目</span>
        </Link>
        <Link 
          to="/service-area"
          className="text-cyan-600 font-semibold cursor-pointer whitespace-nowrap flex items-center gap-1.5 group"
        >
          <i className="ri-map-pin-line text-base group-hover:scale-110 transition-transform"></i>
          <span>服務範圍</span>
        </Link>
      </div>

      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-cyan-600 via-teal-600 to-cyan-700 text-white overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://readdy.ai/api/search-image?query=Beautiful%20Yilan%20County%20Taiwan%20landscape%20with%20mountains%20lakes%20hot%20springs%20traditional%20buildings%20and%20green%20countryside%2C%20professional%20moving%20service%20background%2C%20bright%20daylight%20scene%20with%20clear%20blue%20sky&width=1920&height=1080&seq=yilan-hero-2026&orientation=landscape"
            alt="宜蘭縣風景"
            className="w-full h-full object-cover object-center opacity-20"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-cyan-600/80 to-teal-600/80"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full text-white text-sm font-medium mb-6 border border-white/30">
              <i className="ri-map-pin-line text-lg"></i>
              <span>宜蘭縣專業搬家服務</span>
            </div>

            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              宜蘭縣搬家服務
            </h1>
            <p className="text-xl md:text-2xl text-cyan-50 max-w-3xl mx-auto mb-4">
              建鈞精緻搬家｜宜蘭市、羅東鎮、蘇澳鎮、礁溪鄉全區域專業服務
            </p>
            <div className="flex flex-wrap justify-center gap-2 text-sm mb-8">
              <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">宜蘭市搬家</span>
              <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">羅東鎮搬家</span>
              <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">蘇澳鎮搬家</span>
              <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">礁溪鄉搬家</span>
              <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">冬山鄉搬家</span>
            </div>

            {/* 快速聯絡 */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="tel:0978900081"
                className="inline-flex items-center justify-center gap-3 bg-white text-cyan-600 px-8 py-4 rounded-full font-bold text-lg hover:bg-cyan-50 transition-all shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap"
              >
                <i className="ri-phone-fill text-2xl"></i>
                <span>0978-900-081</span>
              </a>
              <a
                href="https://line.me/ti/p/@285yavdh"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-3 bg-green-500 text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-green-600 transition-all shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap border-2 border-white"
              >
                <i className="ri-line-fill text-2xl"></i>
                <span>LINE 免費估價</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* 服務區域 */}
      <section className="py-20 bg-gradient-to-br from-cyan-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              宜蘭縣搬家服務範圍
            </h2>
            <p className="text-lg text-gray-600">
              12個鄉鎮市全面覆蓋，山區海岸皆可服務
            </p>
          </div>

          {/* 主要服務區域 */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            {services.map((service, index) => (
              <div key={index} className={`bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all hover:-translate-y-1 border-l-4 border-${service.color}-500`}>
                <div className="p-8">
                  <div className="flex items-center mb-6">
                    <div className={`w-16 h-16 bg-${service.color}-100 rounded-xl flex items-center justify-center mr-4`}>
                      <i className={`${service.icon} text-3xl text-${service.color}-600`}></i>
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900">{service.title}</h3>
                  </div>
                  <p className="text-gray-600 mb-6 leading-relaxed">{service.description}</p>
                  <div className="mb-4">
                    <h4 className="text-sm font-bold text-gray-700 mb-3">主要服務地點：</h4>
                    <div className="flex flex-wrap gap-2">
                      {service.areas.map((area, areaIndex) => (
                        <span key={areaIndex} className={`text-xs bg-${service.color}-50 text-${service.color}-700 px-3 py-1 rounded-full`}>
                          {area}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* 所有鄉鎮市 */}
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
              宜蘭縣12鄉鎮市完整服務
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              {districts.map((district, index) => (
                <div 
                  key={index} 
                  className={`p-4 rounded-xl transition-all hover:shadow-md ${
                    district.highlight 
                      ? 'bg-gradient-to-r from-cyan-50 to-teal-50 border-2 border-cyan-200 hover:border-cyan-300' 
                      : 'bg-gray-50 hover:bg-gray-100'
                  }`}
                >
                  <div className="flex items-center justify-between mb-2">
                    <h4 className={`font-bold text-lg ${district.highlight ? 'text-cyan-700' : 'text-gray-800'}`}>
                      {district.name}
                    </h4>
                    {district.highlight && (
                      <span className="bg-cyan-500 text-white text-xs px-2 py-1 rounded-full">熱門</span>
                    )}
                  </div>
                  <p className="text-sm text-gray-600">{district.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              宜蘭搬家常見問題
            </h2>
            <p className="text-lg text-gray-600">
              為您解答宜蘭搬家的各種疑問
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {faqs.map((faq, index) => (
              <div 
                key={index} 
                className="bg-gradient-to-br from-cyan-50 to-teal-50 rounded-xl p-6 shadow-md hover:shadow-xl transition-all hover:-translate-y-1"
              >
                <div className="flex items-start gap-3 mb-3">
                  <div className="w-8 h-8 bg-cyan-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-question-line text-cyan-600"></i>
                  </div>
                  <h3 className="font-bold text-lg text-gray-900">{faq.question}</h3>
                </div>
                <p className="text-gray-600 leading-relaxed pl-11">{faq.answer}</p>
              </div>
            ))}
          </div>

          <div className="text-center mt-8">
            <Link
              to="/faq"
              className="inline-flex items-center gap-2 text-cyan-600 hover:text-cyan-700 font-semibold transition-colors"
            >
              查看更多常見問題
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* 服務特色 */}
      <section className="py-20 bg-gradient-to-br from-cyan-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              宜蘭搬家服務特色
            </h2>
            <p className="text-lg text-gray-600">
              專為宜蘭地區特色量身打造的搬家服務
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((feature, index) => (
              <div key={index} className="text-center bg-white rounded-2xl p-8 shadow-md hover:shadow-xl transition-all hover:-translate-y-1">
                <div className={`w-20 h-20 bg-${feature.color}-100 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg hover:scale-110 transition-transform`}>
                  <i className={`${feature.icon} text-4xl text-${feature.color}-600`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 客戶見證 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              宜蘭客戶真實見證
            </h2>
            <p className="text-lg text-gray-600">
              來自宜蘭鄉親的真實回饋
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-gradient-to-br from-cyan-50 to-teal-50 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all hover:-translate-y-1">
                <div className="flex items-center justify-between mb-4">
                  <div>
                    <h4 className="font-bold text-lg text-gray-900">{testimonial.name}</h4>
                    <p className="text-cyan-600 text-sm">{testimonial.location}</p>
                  </div>
                  <div className="flex text-yellow-400">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-lg"></i>
                    ))}
                  </div>
                </div>
                <p className="text-gray-600 mb-4 leading-relaxed italic">"{testimonial.content}"</p>
                <div className="text-xs text-gray-500 bg-white px-3 py-2 rounded-full inline-block">
                  服務項目：{testimonial.service}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 鄰近地區服務 */}
      <section className="py-20 bg-gradient-to-br from-cyan-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              鄰近地區也有服務
            </h2>
            <p className="text-lg text-gray-600">
              跨縣市搬家也交給我們
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {nearbyAreas.map((area, index) => (
              <Link
                key={index}
                to={area.path}
                className="group bg-white rounded-2xl p-6 shadow-md hover:shadow-xl transition-all hover:-translate-y-1 border-2 border-cyan-100 hover:border-cyan-300"
              >
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-xl font-bold text-cyan-700 group-hover:text-cyan-800">
                    {area.name}
                  </h3>
                  <i className="ri-arrow-right-line text-cyan-600 group-hover:translate-x-1 transition-transform"></i>
                </div>
                <p className="text-gray-600">{area.description}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-cyan-600 via-teal-600 to-cyan-700 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full text-white text-sm font-medium mb-6 border border-white/30">
            <i className="ri-award-line text-lg"></i>
            <span>宜蘭在地搬家專家</span>
          </div>

          <h2 className="text-3xl md:text-5xl font-bold mb-6">
            立即預約宜蘭搬家服務
          </h2>
          <p className="text-xl text-cyan-50 mb-10 max-w-2xl mx-auto">
            10年在地經驗，熟悉宜蘭各鄉鎮特色，溫泉區、山區、海岸都能專業服務
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <a
              href="tel:0978900081"
              className="inline-flex items-center justify-center gap-3 bg-white text-cyan-600 px-8 py-4 rounded-full font-bold text-lg hover:bg-cyan-50 transition-all shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap"
            >
              <i className="ri-phone-line text-2xl"></i>
              <span>立即來電：0978-900-081</span>
            </a>
            <a
              href="https://line.me/ti/p/@285yavdh"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-3 bg-green-500 text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-green-600 transition-all shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap border-2 border-white"
            >
              <i className="ri-line-fill text-2xl"></i>
              <span>LINE 免費諮詢</span>
            </a>
          </div>

          {/* 服務保證 */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mx-auto">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20 hover:bg-white/20 transition-all">
              <i className="ri-shield-check-line text-3xl mb-2"></i>
              <div className="text-sm">全程保險</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20 hover:bg-white/20 transition-all">
              <i className="ri-time-line text-3xl mb-2"></i>
              <div className="text-sm">準時服務</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20 hover:bg-white/20 transition-all">
              <i className="ri-money-dollar-circle-line text-3xl mb-2"></i>
              <div className="text-sm">價格透明</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20 hover:bg-white/20 transition-all">
              <i className="ri-customer-service-2-line text-3xl mb-2"></i>
              <div className="text-sm">24小時客服</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default YilanAreaPage;
